import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  Routes,
  Route,
} from 'react-router-dom';
import DataTable from '../../common/components/DataTable';
import SalaryReviews from '../components/Reports/SalaryReviews';

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

function Salaries() {
  return (
    <Routes>
      <Route path="april" element={<SalaryReviews.April />} />
      <Route path="october" element={<SalaryReviews.October />} />
      <Route path="role" element={<SalaryByRole />} />
      <Route path="all" element={<AllSalaries />} />
    </Routes>
  );
}

function AllSalaries() {
  return <SalaryReviews.Summary />;
}

function SalaryByRole() {
  return (
    <>
      <RoleSalaries roleId={55} title="Software Engineering" />
      <RoleSalaries roleId={60} title="Quality Engineering" />
      <RoleSalaries roleId={56} title="Business Analysis" />
      <RoleSalaries roleId={57} title="Quality Engineering" />
    </>
  );
}

function RoleSalaries({ roleId, title }) {
  return (
    <Row>
      <Col md={12}>
        <DataTable
          className
          url={`/resource/salary/by-role/${roleId}`}
          title={title}
          columns={['Role', 'Min', 'Avg', 'Max']}
          renderRow={(job) => (
            <tr>
              <th>
                <div>{job.title}</div>
                <div className="text-muted small">
                  {job.admin_title}
                </div>
              </th>
              <td>{formatter.format(job.min)}</td>
              <td>{formatter.format(job.avg)}</td>
              <td>{formatter.format(job.max)}</td>
            </tr>
          )}
        />
      </Col>
    </Row>
  );
}

export default Salaries;
